<template>
  <div class="container" style="position: relative;min-height: 100vh;padding-bottom: 100px;">
    <Header class="is-uppercase has-text-weight-bold" />
    <slot></slot>
    <Footer class="is-uppercase has-text-weight-bold" style="width: 100%;position: relative;bottom: 0px;left:0;" />
  </div>
</template>

<script>
import Header from '@/components/LangKyf/Header'
import Footer from '@/components/LangKyf/Footer'

export default {
  name: 'LayoutHF',
  components: {
    Header,
    Footer
  }
}
</script>




// WEBPACK FOOTER //
// src/layouts/Kyf.vue